import React from 'react';

export const GlobalContext = React.createContext();

export const GlobalStorage = ({ children }) => {
  const [msgAlerta, setMsgAlerta] = React.useState(null);
  const timeoutRef = React.useRef();
  const [modalData, setModalData] = React.useState(null);
  const [modalInfoData, setModalInfoData] = React.useState(null);

  return (
    <GlobalContext.Provider
      value={{
        msgAlerta,
        setMsgAlerta,
        timeoutRef,
        modalData,
        setModalData,
        modalInfoData,
        setModalInfoData,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
